
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { ThemeFormValues } from './use-branding-form';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';

interface ColorPaletteProps {
  form: UseFormReturn<ThemeFormValues>;
}

export function ColorPalette({ form }: ColorPaletteProps) {
  const primaryColor = form.watch('primaryColor');
  const secondaryColor = form.watch('secondaryColor');
  const accentColor = form.watch('accentColor');
  
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <ColorPicker 
          name="primaryColor"
          label="Color Primario"
          value={primaryColor}
          onChange={(value) => form.setValue('primaryColor', value)}
          className="border-primary"
        />
        
        <ColorPicker 
          name="secondaryColor"
          label="Color Secundario"
          value={secondaryColor}
          onChange={(value) => form.setValue('secondaryColor', value)}
          className="border-secondary"
        />
        
        <ColorPicker 
          name="accentColor"
          label="Color de Acento"
          value={accentColor}
          onChange={(value) => form.setValue('accentColor', value)}
          className="border-accent"
        />
      </div>
      
      <div className="p-4 rounded-lg bg-gray-100 dark:bg-gray-800">
        <h4 className="text-sm font-medium mb-2">Vista previa</h4>
        <div className="flex flex-wrap gap-2">
          <div 
            className="w-20 h-10 rounded" 
            style={{ backgroundColor: primaryColor }}
            title="Color Primario"
          />
          <div 
            className="w-20 h-10 rounded" 
            style={{ backgroundColor: secondaryColor }}
            title="Color Secundario"
          />
          <div 
            className="w-20 h-10 rounded" 
            style={{ backgroundColor: accentColor }}
            title="Color de Acento"
          />
        </div>
      </div>
    </div>
  );
}

interface ColorPickerProps {
  name: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

function ColorPicker({ name, label, value, onChange, className }: ColorPickerProps) {
  return (
    <div className="space-y-2">
      <Label htmlFor={name}>{label}</Label>
      <div className="flex items-center gap-2">
        <div 
          className={cn(
            "w-10 h-10 rounded border-2", 
            className
          )}
          style={{ backgroundColor: value }}
        />
        <Input
          id={name}
          type="color"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="w-10 h-10 p-0 overflow-hidden border-0"
        />
        <Input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="flex-1"
        />
      </div>
    </div>
  );
}
